import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float, ID, Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { Validator } from '@adornis/validation/validator.js';
import { getLodasNumberForLohnart } from '../../../db/import-export/generateLohnart.js';
import type { Lohnart } from '../../enums/Lohnart.js';

@Entity()
export class Zahlung extends AdornisEntity {
  static override _class = 'Zahlung';

  @Field(type => ID, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;

  @Field(type => String)
  lohnart: Maybe<Lohnart>;

  @Field(type => Int, {
    resolve: function (this: Zahlung) {
      return () => {
        if (!this.lohnart) return null;
        return getLodasNumberForLohnart(this.lohnart);
      };
    },
  })
  lohnartNumber: Maybe<number>;

  @Field(type => Float)
  betrag: Maybe<number>;

  @Field(type => Int)
  monat: Maybe<number>;

  @Field(type => Int)
  jahr: Maybe<number>;
}

if (A.isClient) {
  Zahlung.prototype.validator = new Validator({
    lohnart: nonOptional(),
    betrag: nonOptional(),
  });
}
